import { connect } from 'react-redux';
import { editDeviation } from '../../../redux/deviations/actionCreators';
var mapDispatchToProps = {
    onClick: editDeviation,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=EditButton.container.js.map